import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDmCyErY16DK0Gyer07F-2DixMnqKVTJz8",
  authDomain: "jmc-main.firebaseapp.com",
  projectId: "jmc-main",
  storageBucket: "jmc-main.firebasestorage.app",
  messagingSenderId: "412834954358",
  appId: "1:412834954358:web:fba5686354605208847357",
};

// ✅ Initialize Firebase
export const app = initializeApp(firebaseConfig);

// ✅ Initialize Services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const analytics = getAnalytics(app);
export const storage = getStorage(app);
